export default "__VITE_ASSET__DJQXw7yY__"